module.exports = __webpack_public_path__ + "assets/img/service4.d4786c40.png";